module.exports = __webpack_public_path__ + "media/images/bar_one-e6046a93f02396c37467dac1ce141823.png";